import youtubeVideoTemplate from './youtube_video.template.html';

class WbYoutubeVideoController {

    constructor($sce) {
        'ngInject';

        const injectables = {
            $sce
        };

        Object.assign(this, injectables);
    }

    $onInit() {
        if (this.youtubeId) {
            this.youtubeUrl = `https://www.youtube.com/embed/${this.youtubeId}`;
        }
    }

    trustSrc(src) {
        return this.$sce.trustAsResourceUrl(src);
    }
}

const WbYouTubeVideoComponent = {
    templateUrl: youtubeVideoTemplate.id,
    controller: WbYoutubeVideoController,
    controllerAs: '$wbYouTubeVideoCtrl',
    bindings: {
        youtubeId: '<'
    }
};

angular
    .module('westBerkshireEvents.youtubeVideo')
    .component('wbYoutubeVideo', WbYouTubeVideoComponent);

export default WbYoutubeVideoController;


// WEBPACK FOOTER //
// ../src/public/javascripts/youtube-video/youtube_video.component.js